<template>
  <div class="home-below">
    <b-container fluid id="main-container">
      <section class="main-content">
        <b-row class="justify-content-center" v-if="specials.length">
          <b-col md="10">
            <b-card class="special-offers" align="center">
              <b-card-title class="title-left">Special Offers</b-card-title>
              <b-card-title class="title-right">Special Offers</b-card-title>
              <b-row
                class="justify-content-center"
                v-for="special in specials"
                :key="special.id"
              >
                <b-col md="10">
                  <b-card class="special-offers-inner" align="center">
                    <b-card-title>{{ special.title }}</b-card-title>
                    <b-card-text>{{ special.description }}</b-card-text>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <b-row class="justify-content-center">
          <b-col lg="6" class="align-self-center mb-md-3 mb-lg-0">
            <h3>Serving The Oswego Community For Over 20 Years!</h3>
            <p>
              Dickquist Quality Used Autos has been proud to be part of the
              Oswego community since 2000, and has been dedicated to serving our
              customer's needs for over 20 years. We provide quality car sales
              as well as quality auto repair through our trusted staff. You do
              not need to look any further for competitive pricing. We know that
              there are other auto service shops and car dealers to choose from
              that's why. When our customers walk through the door, they are
              provided our very best from start to finish. Don't hesitate visit
              our website and get pre-approved with our various financing
              options today - no matter your credit!
            </p>
          </b-col>
          <b-col lg="6" class="p-md-3">
            <picture>
              <source
                type="image/webp"
                srcset="../../assets/main/mechanic/mechanic-small.webp"
                media="(max-width:600px)"
              />
              <source
                type="image/jpeg"
                srcset="../../assets/main/mechanic/mechanic-small.jpeg"
                media="(max-width:600px)"
              />

              <source
                type="image/webp"
                srcset="../../assets/main/mechanic/mechanic-medium.webp"
                media="(max-width:1000px)"
              />
              <source
                type="image/jpeg"
                srcset="../../assets/main/mechanic/mechanic-medium.jpeg"
                media="(max-width:1000px)"
              />

              <source
                type="image/webp"
                srcset="../../assets/main/mechanic/mechanic.webp"
              />
              <img
                loading="lazy"
                alt="Picture of auto repair mechanic"
                src="../../assets/main/mechanic/mechanic.jpeg"
              />
            </picture>
          </b-col>
        </b-row>
      </section>
      <section class="links">
        <b-row align-self="center">
          <b-col sm="12" md="4" align-self="start">
            <div class="hover">
              <router-link id="link" to="Services">
                <h4>Service</h4>
                <picture>
                  <source
                    srcset="../../assets/main/links/service-small.webp"
                    type="image/webp"
                  />
                  <source
                    srcset="../../assets/main/links/service-small.jpg"
                    type="image/jpg"
                  />
                  <img
                    loading="lazy"
                    src="../../assets/main/links/service-small.jpg"
                    alt="An image of auto repair"
                    class="link-image"
                  />
                </picture>
              </router-link>
            </div>
          </b-col>
          <b-col sm="12" md="4" align-self="start">
            <div class="hover">
              <router-link id="link" to="PreApproved">
                <h4>Get Pre-Approved</h4>
                <picture>
                  <source
                    srcset="../../assets/main/links/legal-small.webp"
                    type="image/webp"
                  />
                  <source
                    srcset="../../assets/main/links/legal-small.jpg"
                    type="image/jpg"
                  />
                  <img
                    loading="lazy"
                    src="../../assets/main/links/legal-small.jpg"
                    alt="An image of legal paperwork"
                    class="link-image"
                  />
                </picture>
              </router-link>
            </div>
          </b-col>
          <b-col sm="12" md="4" align-self="start">
            <div class="hover">
              <router-link id="link" to="Cars">
                <h4>Inventory</h4>
                <picture>
                  <source
                    srcset="../../assets/main/links/cars-small.webp"
                    type="image/webp"
                  />
                  <source
                    srcset="../../assets/main/links/cars-small.jpg"
                    type="image/jpg"
                  />
                  <img
                    loading="lazy"
                    src="../../assets/main/links/cars-small.jpg"
                    alt="An image of keys"
                    class="link-image"
                  />
                </picture>
              </router-link>
            </div>
          </b-col>
        </b-row>
      </section>
      <section class="bottom">
        <b-row class="justify-content-around">
          <b-col md="5">
            <b-card class="my-card" align="center">
              <b-card-title>
                Why Should You Choose Dickquist Quality Used Autos?
              </b-card-title>
              <b-card-text>
                Well for us the answer is simple trust and dedication to our
                customers. That is what we have been about for over 20 years.
                When you are looking to buy a car or your car needs maintenance
                you want to go to someone you can trust and that's where we come
                in. With our team of trained mechanics you can rest assured that
                you will be treated with nothing but respect. Here at Dickquist
                Quality Used Autos we treat each car that comes in as if it is
                our own. So next time you are looking to buy a car or need a
                tune-up look no further come to Dickquist Quality Used Autos.
              </b-card-text>
            </b-card>
          </b-col>
          <b-col md="5">
            <b-card class="my-card" align="center">
              <b-card-title>Visited Us Lately?</b-card-title>
              <b-card-sub-title>Let us know how we did</b-card-sub-title>

              <b-form
                :validated="validated"
                @submit.prevent="addReview"
                name="review-form"
                novalidate
              >
                <div class="name">
                  <label class="sr-only" for="form-input-name">Name</label>
                  <b-input
                    id="form-input-name"
                    class="form-inputs mb-2"
                    v-model="name"
                    placeholder="Name"
                    required
                    :state="isStateValid(this.name)"
                  ></b-input>
                  <b-form-invalid-feedback id="form-input-name">
                    You must enter a name
                  </b-form-invalid-feedback>
                </div>

                <div class="date">
                  <label class="sr-only" for="example-datepicker">
                    Choose a date
                  </label>
                  <b-form-datepicker
                    id="datepicker"
                    v-model="dateVisited"
                    class="mb-2"
                    required
                    placeholder="Date Visited"
                    :state="isStateValid(this.dateVisited)"
                  ></b-form-datepicker>
                  <b-form-invalid-feedback id="datepicker">
                    You must enter a valid date
                  </b-form-invalid-feedback>
                </div>

                <div class="service">
                  <label class="sr-only" for="form-input-service"
                    >Service Provided</label
                  >
                  <b-input
                    id="form-input-service"
                    class="form-inputs mb-2"
                    placeholder="Service Provided"
                    v-model="service"
                    required
                    :state="isStateValid(this.service)"
                  ></b-input>
                  <b-form-invalid-feedback id="form-input-service">
                    You must enter the service provided
                  </b-form-invalid-feedback>
                </div>

                <div class="email">
                  <label class="sr-only" for="inline-form-input-username"
                    >Email</label
                  >
                  <b-input
                    id="inline-form-input-username"
                    class="form-control mb-2"
                    placeholder="Email"
                    v-model="email"
                    required
                    :state="emailStateValidation"
                  ></b-input>
                  <b-form-invalid-feedback id="inline-form-input-username">
                    You must enter the part of your email that comes before the
                    '@' symbol
                  </b-form-invalid-feedback>
                </div>

                <div class="domain">
                  <label class="sr-only" for="inline-form-input-domain"
                    >Domain</label
                  >
                  <b-input-group prepend="@" class="mb-2">
                    <b-input
                      class="domain"
                      id="inline-form-input-domain"
                      placeholder="Domain ex: gmail.com"
                      v-model="domain"
                      :state="domainStateValidation"
                      required
                    ></b-input>
                    <b-form-invalid-feedback id="inline-form-input-domain">
                      You must enter the part of your email that comes after the
                      '@' symbol
                    </b-form-invalid-feedback>
                  </b-input-group>
                </div>

                <div class="description">
                  <label class="sr-only" for="textarea-rows"
                    >Describe Your Experience</label
                  >
                  <b-form-textarea
                    class="mb-3"
                    id="textarea-rows"
                    placeholder="Describe Your Experience"
                    rows="4"
                    required
                    v-model="description"
                    :state="isStateValid(this.description)"
                  ></b-form-textarea>
                  <b-form-invalid-feedback class="mb-3" id="textarea-rows">
                    You must enter a description of your experience
                  </b-form-invalid-feedback>
                </div>

                <b-button type="submit" @click="validate()">
                  Post Review
                </b-button>
              </b-form>
            </b-card>
          </b-col>

          <b-col
            md="5"
            v-for="permanentPost in permanentPosts"
            :key="permanentPost.id"
          >
            <b-card class="my-card" align="center">
              <b-card-title>{{ permanentPost.title }}</b-card-title>
              <b-card-text>{{ permanentPost.description }}</b-card-text>
            </b-card>
          </b-col>
        </b-row>
      </section>
    </b-container>
  </div>
</template>

<script>
  import firebase from "@/firebase/init";
  export default {
    data() {
      return {
        specials: [],
        permanentPosts: [],
        name: "",
        service: "",
        email: "",
        domain: "",
        description: "",
        dateVisited: "",
        validated: false,
      };
    },
    created() {
      this.getSpecialOffers();
      this.getPermanentPosts();
    },
    beforeUpdate() {
      if (this.dateVisited) {
        let invalidDate = document.getElementsByClassName("date")[0]
          .lastElementChild;
        console.log(invalidDate);
        invalidDate.stlye.display = "none";
      }
    },
    computed: {
      emailStateValidation() {
        if (this.email) {
          return this.emailIsValid() ? true : false;
        }
        return null;
      },
      domainStateValidation() {
        if (this.domain) {
          return this.domainIsValid() ? true : false;
        }
        return null;
      },
    },
    methods: {
      emailIsValid() {
        let regEx = /^(?!.*@)((^[^\.])[a-z0-9\.!#$%&'*+\-\/=?^_`{|}~"]*)*([^\.]$)/;
        return regEx.test(this.email);
      },
      domainIsValid() {
        let regEx = /((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regEx.test(this.domain);
      },
      isStateValid(variable) {
        if (this.validated) {
          return variable.length > 0 ? true : false;
        }
        return null;
      },
      validate() {
        this.validated = true;
      },
      getSpecialOffers() {
        let specialOffers = firebase
          .firestore()
          .collection("specialOfferPosts");

        specialOffers
          .where("display", "==", true)
          .get()
          .then((snapshot) => {
            snapshot.forEach((doc) => {
              let special = doc.data();
              special.id = doc.id;
              this.specials.push(special);
            });
          })
          .catch((err) => {
            console.log(err.message);
          });
      },
      getPermanentPosts() {
        firebase
          .firestore()
          .collection("permanentPosts-home")
          .get()
          .then((snapshot) => {
            snapshot.forEach((doc) => {
              let permanentPost = doc.data();
              permanentPost.id = doc.id;
              this.permanentPosts.push(permanentPost);
            });
          })
          .catch((err) => {
            console.log(err.message);
          });
      },
      addReview() {
        firebase
          .firestore()
          .collection("reviews")
          .add({
            name: this.name,
            date: this.dateVisited,
            service: this.service,
            email: this.email + "@" + this.domain,
            timestamp: Date.now(),
            description: this.description,
          })
          .then(() => {
            let mainForm = document.getElementsByName("review-form")[0];

            mainForm.reset(); // Reset all form data

            this.name = "";
            this.dateVisited = "";
            this.service = "";
            this.email = "";
            this.description = "";
          })
          .catch((err) => {
            alert("We are sorry an error has occured please try again later");
            console.log(err.message);
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/components/home/home-below-fold.scss";
</style>
